import {
  ARROW_TOTAL_WIDTH,
  CARD_WIDTH,
  DIFF_BETWEEN_SMALL_BIG,
  PADDING,
  SMALL_CARD_WIDTH,
} from "@features/pulse/variant/control/utils/constants";

export const getTheCardLeftCss = (
  activeArticle: number,
  index: number
): string => {
  const firstCardIndex = activeArticle - 1;
  const secondCardIndex = activeArticle;
  const thirdCardIndex = activeArticle + 3;

  const currentPositionIndex = index - (activeArticle - 1);

  if (firstCardIndex === index) {
    return "0";
  }

  if (secondCardIndex > index) {
    return `calc(-1 * ${SMALL_CARD_WIDTH + ARROW_TOTAL_WIDTH}px)`;
  }

  if (thirdCardIndex === index) {
    return `calc((${CARD_WIDTH + PADDING}px * ${currentPositionIndex}) + ${ARROW_TOTAL_WIDTH}px)`;
  }

  return `calc((${SMALL_CARD_WIDTH + PADDING}px * ${currentPositionIndex}) + ${ARROW_TOTAL_WIDTH}px + ${DIFF_BETWEEN_SMALL_BIG}px)`;
};
